<div class="row" dir="rtl" >
    <div class="col-lg-12" style="text-align:right; margin-right: 5px;"><img src="assets/img/logo1.png"/><div class="float-left">
        <a href="#" (click)="logout()">Log out<i class="fas fa-log-out"></i></a>
    </div></div>
    <div class="col-lg-6" style="background-color: rgb(230, 230, 233);height: 100vh;">
        <div style="position: fixed;text-align: right; top:40%;right: 20px;">
            <h4>تعريف بالمشروع</h4>
            <br>
            <p>يهدف هذا المشروع إلى متابعة عملية تصحيح المخططات بمدينة المدينة المنورة</p>
        </div>
    </div>
    <div class="col-lg-6" style="background-color: rgb(197, 230, 211);height: 100vh;">
        <div style="position: fixed;text-align: center; top:40%;left: 25%;">
            <a href="#" class="btn btn-success">adminHome</a><br><br>
             <a href="/landing" class="btn btn-success">landing</a><br><br>
            
        </div>
    </div>
</div>